import { List, fromJS } from 'immutable';
import config from 'react-global-configuration';
import { ROOT_CLASSES_ADD, ROOT_CLASSES_REMOVE, LANGUAGE_SET, DISABLE_MAINTENANCE_MODE, ENABLE_MAINTENANCE_MODE, SET_CHECKBOX, PERMISSIONS_LOADED, UI_OPERATION_SET_STATUS } from '../../actions/UI';
import { REFERENCE_LOADING_START, REFERENCE_LOADING_DONE, REFERENCE_LOADING_RESET, REFERENCE_LOADING_ENABLE_PAGE_LOADER } from '../../actions/UI/ReferenceLoading';

// Guess language by reading the first part of the URL.
var getLanguage = function getLanguage() {
  if (!config.get('MULTILINGUAL', false)) {
    return config.get('DEFAULT_LANGUAGE', '');
  }
  var path = typeof window !== 'undefined' && window.location.pathname;
  if (path && path.split('/')[1].length === 2) {
    return path.split('/')[1];
  } else {
    return config.get('DEFAULT_LANGUAGE', '');
  }
};
var initialState = function initialState() {
  return fromJS({
    language: getLanguage(),
    rootClasses: [],
    maintenanceMode: false,
    referenceLoading: {
      itemsStarted: null,
      itemsFinished: null
    },
    permissions: [],
    roles: [],
    user: {
      operations: {
        login: {
          status: null,
          reason: null
        },
        current: {
          status: null,
          reason: null
        },
        one_time_login: {
          status: null,
          reason: null
        },
        reset_password: {
          status: null,
          reason: null
        },
        update: {
          status: null,
          reason: null
        },
        forgot_password: {
          status: null,
          reason: null
        },
        logout: {
          status: null,
          reason: null
        }
      }
    },
    commerce: {
      operations: {
        cart_load: {
          status: null
        },
        cart_product_add: {
          status: null
        },
        cart_product_remove: {
          status: null
        },
        cart_checkout: {
          status: null
        },
        orders_load: {
          status: null
        }
      }
    },
    fetch: {
      credentials: {
        content: config.get('CONTENT_FETCH_CREDENTIALS', 'include'),
        block: config.get('BLOCK_FETCH_CREDENTIALS'),
        menu: config.get('MENU_FETCH_CREDENTIALS'),
        node: config.get('NODE_FETCH_CREDENTIALS'),
        paragraph: config.get('PARAGRAPH_FETCH_CREDENTIALS'),
        profile: config.get('PROFILE_FETCH_CREDENTIALS'),
        taxonomyTerm: config.get('TAXONOMY_TERM_FETCH_CREDENTIALS'),
        user: config.get('USER_FETCH_CREDENTIALS'),
        view: config.get('VIEW_FETCH_CREDENTIALS'),
        webform: config.get('WEBFORM_FETCH_CREDENTIALS')
      },
      headers: {
        content: config.get('CONTENT_FETCH_HEADERS', {})
      }
    }
  });
};
export default function ui() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState();
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case ENABLE_MAINTENANCE_MODE:
      {
        return state.set('maintenanceMode', true);
      }
    case DISABLE_MAINTENANCE_MODE:
      {
        return state.set('maintenanceMode', false);
      }
    case UI_OPERATION_SET_STATUS:
      {
        return state.setIn([action.payload.type, 'operations', action.payload.operation, 'status'], action.payload.status).setIn([action.payload.type, 'operations', action.payload.operation, 'reason'], action.payload.reason);
      }
    case LANGUAGE_SET:
      {
        return state.set('language', action.language);
      }
    case REFERENCE_LOADING_ENABLE_PAGE_LOADER:
      {
        return state.setIn(['referenceLoading', 'showPageLoader'], true);
      }
    case REFERENCE_LOADING_START:
      {
        var current = state.getIn(['referenceLoading', 'itemsStarted']);
        return state.setIn(['referenceLoading', 'itemsStarted'], current + 1);
      }
    case REFERENCE_LOADING_RESET:
      {
        return state.set('referenceLoading', initialState().get('referenceLoading'));
      }
    case SET_CHECKBOX:
      {
        return state.setIn(['webformState', action.id], action.checked);
      }
    case REFERENCE_LOADING_DONE:
      {
        var _current = state.getIn(['referenceLoading', 'itemsFinished']);
        return state.setIn(['referenceLoading', 'itemsFinished'], _current + 1);
      }
    case ROOT_CLASSES_ADD:
      {
        var classes = List(typeof action.classes === 'string' ? action.classes.split(' ') : action.classes);

        // Filter on those that we have to add.
        var newClasses = classes.filter(function (item) {
          var index = state.get('rootClasses').findIndex(function (c) {
            return c === item;
          });
          return index === -1;
        });
        return state.update('rootClasses', function (list) {
          return list.merge(newClasses);
        });
      }
    case ROOT_CLASSES_REMOVE:
      {
        var _classes = List(typeof action.classes === 'string' ? action.classes.split(' ') : action.classes);
        return state.update('rootClasses', function (list) {
          return list.filter(function (item) {
            var index = _classes.findIndex(function (c) {
              return c === item;
            });
            return index === -1;
          });
        });
      }
    case PERMISSIONS_LOADED:
      {
        return state.set('permissions', fromJS(action.payload.permissions)).set('roles', fromJS(action.payload.roles));
      }
    default:
      return state;
  }
}